import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Col, Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import {
  isJsonValueEmpty,
  isInt,
  isValueEmpty,
  getUtcToLocalByFormat,
  containsSpecialChars,
} from '@awp/helpers/utilsReact';
import { isValid, setHours, setMinutes, subDays, format as formatDate } from 'date-fns';
import {
  isEditing,
  getSelectedSegment,
  getOrignSegment,
  getSaveSegmentError,
  getSensors,
  setEditing,
  setSegment,
  setOrignSegment,
  saveSegment,
  setSaveSegmentError,
} from '@stores/sensorEquipmentPacketSlice';

const txtFontSize = {
  fontSize: '85%',
};

const SegmentEdit = ({ segment }) => {
  const dispatch = useDispatch();
  const selectedSegment = useSelector(getSelectedSegment);
  const saveSegmentError = useSelector(getSaveSegmentError);
  const sensorList = useSelector(getSensors);

  const updateSourceName = (e) => {
    e.preventDefault();
    dispatch(setSaveSegmentError(null));
    let _selectedSegment = { ...selectedSegment };
    _selectedSegment.SourceName = e.target.value + '';
    if (containsSpecialChars(_selectedSegment.SourceName)) {
      let psErrs = {};
      let valsEt1 = [];
      valsEt1.push('Name contains invalid character.');
      psErrs['PlacementSegment.SourceName.' + selectedSegment.Id] = valsEt1;
      dispatch(setSaveSegmentError(psErrs));
    }
    dispatch(setSegment(_selectedSegment));
  };
  const updateTimeInterval = (e) => {
    e.preventDefault();

    let _selectedSegment = { ...selectedSegment };
    _selectedSegment.CollectionIntervalMinutes = e.target.value + '';
    dispatch(setSegment(_selectedSegment));
  };

  const updateSensor = (e) => {
    const id = e ? e.value + '' : '';
    let _selectedSegment = { ...selectedSegment };
    if (isValueEmpty(id)) {
      _selectedSegment.SensorId = null;
      _selectedSegment.Sensor = null;
    } else {
      const senr = sensorList.find((opt) => opt.value == id);
      _selectedSegment.SensorId = senr.value;
      _selectedSegment.Sensor = senr.sensor;
    }
    dispatch(setSegment(_selectedSegment));
  };

  const strDateTime = (ts) => {
    return ((formatDate(new Date(ts), 'yyyy-MM-dd HH:mm') + '').toString().replace(' ', 'T') + '')
      .toString()
      .replace(' ', 'T');
  };

  const getError = (field) => {
    if (isJsonValueEmpty(saveSegmentError)) return '';
    let err = { ...saveSegmentError };
    //check property of dict obj
    field = (field + '').toLocaleLowerCase();
    for (let key in err) {
      let k = key.toLocaleLowerCase();
      if (!isValueEmpty(key) && k.startsWith(field)) {
        let id = k.replace(field + '.', '');
        if (isInt(id)) {
          if (selectedSegment.Id + '' === id + '') {
            return err[key];
          }
        }
      }
    }
    return '';
  };
  const getSensorLabel = () => {
    let _selectedSegment = { ...selectedSegment };
    if (
      isValueEmpty(_selectedSegment.SensorId) ||
      !_selectedSegment.Sensor ||
      isJsonValueEmpty(_selectedSegment.Sensor)
    )
      return '';
    let sn = isValueEmpty(_selectedSegment.Sensor.SerialNumber) ? '' : _selectedSegment.Sensor.SerialNumber;
    let mn = isValueEmpty(_selectedSegment.Sensor.ModelNumber) ? '' : _selectedSegment.Sensor.ModelNumber;
    let mf = isValueEmpty(_selectedSegment.Sensor.Manufacturer) ? '' : _selectedSegment.Sensor.Manufacturer;
    if (isValueEmpty(sn) && isValueEmpty(mn) && isValueEmpty(mf)) return '';
    return `${sn} - ${mn} - ${mf}`;
  };

  return (
    selectedSegment && (
      <>
        <Col md={2}>
          <Form.Group>
            <Form.Label>
              <b>Source Name</b>
            </Form.Label>
            <br />
            <Form.Control
              onChange={updateSourceName}
              className="text-size85"
              type="text"
              maxLength="50"
              value={isValueEmpty(selectedSegment.SourceName) ? '' : selectedSegment.SourceName}
              //className={getSensorOservationTypeStyleState("dno"+sensorObservationType.Id)}
            />
            {!isValueEmpty(getError('PlacementSegment.SourceName')) && (
              <Form.Control.Feedback type="invalid" className="d-block">
                {getError('PlacementSegment.SourceName')}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>
              <b>Start Date</b>
            </Form.Label>
            <br />
            <div style={{ width: '100%' }}>
              <DatePicker
                selected={
                  isValueEmpty(selectedSegment.SegmentEffectiveTimestamp)
                    ? ''
                    : new Date(strDateTime(selectedSegment.SegmentEffectiveTimestamp))
                }
                className="form-control input-sm text-size85"
                dateFormat={['yyyy-MM-dd HH:mm', 'yyyy-MM-dd', 'yyyyMMdd', 'yyyyMMddHHmm']}
                showTimeSelect
                closeOnSelect={true}
                timeFormat="HH:mm"
                timeIntervals={60}
                style={txtFontSize}
                //disabled={loading == STATE_STATUS.LOADING|| false}
                onChange={(date) => {
                  if (isValid(date)) {
                    let _selectedSegment = { ...selectedSegment };
                    _selectedSegment.SegmentEffectiveTimestamp = strDateTime(date);
                    dispatch(setSegment(_selectedSegment));
                  }
                }}
              />
            </div>
            {!isValueEmpty(getError('PlacementSegment.SegmentEffectiveTimestamp')) && (
              <Form.Control.Feedback type="invalid" className="d-block">
                {getError('PlacementSegment.SegmentEffectiveTimestamp')}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>
              <b>End Date</b>
            </Form.Label>
            <br />
            <div style={{ width: '100%' }}>
              <DatePicker
                selected={
                  isValueEmpty(selectedSegment.SegmentEndTimestamp)
                    ? ''
                    : new Date(strDateTime(selectedSegment.SegmentEndTimestamp))
                }
                className="form-control input-sm text-size85"
                dateFormat={['yyyy-MM-dd HH:mm', 'yyyy-MM-dd', 'yyyyMMdd', 'yyyyMMddHHmm']}
                showTimeSelect
                closeOnSelect={true}
                timeFormat="HH:mm"
                timeIntervals={60}
                //disabled={loading == STATE_STATUS.LOADING|| false}
                onChange={(date) => {
                  if (isValid(date) || isValueEmpty(date)) {
                    let _selectedSegment = { ...selectedSegment };
                    _selectedSegment.SegmentEndTimestamp = isValueEmpty(date) ? '' : strDateTime(date);
                    dispatch(setSegment(_selectedSegment));
                  }
                }}
              />
            </div>
            {!isValueEmpty(getError('PlacementSegment.SegmentEndTimestamp')) && (
              <Form.Control.Feedback type="invalid" className="d-block">
                {getError('PlacementSegment.SegmentEndTimestamp')}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>
              <b>Sensor</b>
            </Form.Label>
            <br />
            <div style={txtFontSize}>
              <Select
                id={'sensorPrefix_' + selectedSegment.Id + ''}
                options={sensorList}
                isClearable={true}
                value={{
                  value: selectedSegment.SensorId,
                  label: getSensorLabel(),
                }}
                placeholder={'Select ...'}
                onChange={updateSensor}
              />
            </div>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>
              <b>Polling Interval</b>
            </Form.Label>
            <br />
            <select
              id={`pollInterval-${selectedSegment.Id + ''}`}
              onChange={updateTimeInterval}
              className="form-control form-control-sm"
            >
              {isValueEmpty(selectedSegment.CollectionIntervalMinutes) ? (
                <option value="60">{'60 mins'}</option>
              ) : (
                <option value={selectedSegment.CollectionIntervalMinutes}>
                  {selectedSegment.CollectionIntervalMinutes + ' mins'}
                </option>
              )}
              {[15, 30, 60].map((poll, i) => {
                return (
                  <option key={`spl_edit_${selectedSegment.Id + ''}_select_poll_interval_${i}`} value={poll}>
                    {poll + ' mins'}
                  </option>
                );
              })}
            </select>
          </Form.Group>
        </Col>
      </>
    )
  );
};

SegmentEdit.propTypes = {
  segment: PropTypes.any.isRequired,
};

export default SegmentEdit;
